// src/components/AFIPStatusBadge.js
import React, { useState, useEffect } from 'react';
import { Tooltip, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { PiPlugsConnectedBold } from 'react-icons/pi';
import { TbPlugConnectedX } from 'react-icons/tb';
import afipQueueService from '../services/afipQueueService';

const AFIPStatusBadge = ({ collapsed }) => {
    const [afipHealth, setAfipHealth] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchAfipHealth = async () => {
        setLoading(true);
        try {
            const result = await afipQueueService.checkAFIPHealth();
            if (result.success && result.data) {
                setAfipHealth(result.data);
            } else {
                setAfipHealth({ isHealthy: false });
            }
        } catch (error) {
            console.error("Error fetching AFIP health:", error);
            setAfipHealth({ isHealthy: false });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAfipHealth();
        
        // Poll AFIP health every 60 seconds
        const interval = setInterval(fetchAfipHealth, 60000);
        
        return () => clearInterval(interval);
    }, []);

    const statusText = loading ? 'Verificando...' : (afipHealth?.isHealthy ? 'AFIP/ARCA Online' : 'AFIP/ARCA Offline');

    return (
        <div style={{ 
            padding: collapsed ? '8px' : '8px 24px 8px 40px', 
            borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: collapsed ? 'center' : 'space-between',
            gap: '8px'
        }}>
            <Tooltip title={statusText} placement="right">
                <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px',
                    cursor: 'pointer',
                    flex: collapsed ? 'none' : 0
                }} onClick={fetchAfipHealth}>
                    {(afipHealth?.isHealthy || loading) ? (
                        <PiPlugsConnectedBold style={{
                            fontSize: '16px',
                            color: loading ? '#8c8c8c' : '#52c41a'
                        }} />
                    ) : (
                        <TbPlugConnectedX style={{
                            fontSize: '16px',
                            color: '#ff4d4f'
                        }} />
                    )}
                    {!collapsed && (
                        <span style={{ 
                            fontSize: '13px', 
                            color: loading ? '#8c8c8c' : (afipHealth?.isHealthy ? '#52c41a' : '#ff4d4f'),
                            fontWeight: 500,
                            whiteSpace: 'nowrap'
                        }}>
                            {loading ? 'Verificando...' : (afipHealth?.isHealthy ? 'AFIP/ARCA Online' : 'AFIP/ARCA Offline')}
                        </span>
                    )}
                </div>
            </Tooltip>
            {!collapsed && (
                <Tooltip title="Actualizar estado">
                    <Button
                        type="text"
                        size="small"
                        icon={<ReloadOutlined spin={loading} />}
                        onClick={fetchAfipHealth}
                        style={{ 
                            color: 'rgba(255, 255, 255, 0.85)',
                            padding: '4px'
                        }}
                    />
                </Tooltip>
            )}
        </div>
    );
};

export default AFIPStatusBadge;
